import type { infer as ZodInfer } from 'zod';
import { email, file, number, object, string } from 'zod';

export const schema = object({
  reseller_id: number().min(1, 'Du måste välja en återförsäljare'),
  first_name: string().min(1, 'Du måste fylla i ditt förnamn'),
  last_name: string().min(1, 'Du måste fylla i ditt efternamn'),
  phone: string()
    .min(1, 'Du måste fylla i ditt mobiltelefonnummer')
    .refine(
      (val) => /^07\d{8}$/.test(val.replace(/[\s\-]/g, '')),
      'Ange ett giltigt mobilnummer (t.ex. 070 123 45 67)',
    ),
  address: string().min(1, 'Du måste fylla i din gatuadress'),
  city: string().min(1, 'Du måste fylla i din postort'),
  zip: string().regex(/^\d{3}\s?\d{2}$/, 'Ange ett giltigt postnummer'),
  email: email('Ange en giltig e-postadress'),
  image: file({ error: 'Du måste ladda upp en bild' })
    .max(5_242_880, 'Bilden får inte vara större än 5 MB')
    .mime(
      ['image/png', 'image/jpeg', 'image/bmp', 'image/gif', 'image/webp'],
      'Filformatet stöds inte. Välj en PNG, JPEG, BMP, GIF eller WebP-bild',
    ),
});

export type FormWOWValues = ZodInfer<typeof schema>;

export const defaultValues: FormWOWValues = {
  reseller_id: 0,
  first_name: '',
  last_name: '',
  phone: '',
  address: '',
  zip: '',
  city: '',
  email: '',
  image: undefined as unknown as File,
};

export const inputClass =
  'w-full h-[50px] border border-kia-gray rounded px-4 py-3 text-base focus:outline-none focus:border-black focus:ring-1 focus:ring-black transition-colors';
export const inputErrorClass =
  'w-full h-[50px] border border-red-400 rounded px-4 py-3 text-base focus:outline-none focus:border-red-600 transition-colors';
export const labelClass = 'block text-sm font-medium mb-1';

export type SelectionMode =
  | 'idle'
  | 'locating'
  | 'located'
  | 'denied'
  | 'error';

export function haversineKm(
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number,
) {
  const R = 6371;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}
